import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import { CSSProperties } from 'react';
import { CampusDashboardCard } from '../Dashboard/CampusDashboardCard';
import { connect } from 'react-redux';
import * as Request from '../tgccRequest';
import Radium, { StyleRoot } from 'radium';

class Props extends Tgcc.BaseProps {
    userInfo: Tgcc.UserInfo;
    loginData: Tgcc.LoginData;
}

const rowStyle: CSSProperties = {
    padding: '5px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: '11px',
    marginTop: '3px',
};

let addrRow2Style = Object.assign({}, rowStyle, { marginTop: '0', padding: '0px 5px' });
let checkRowStyle = Object.assign({}, rowStyle, { justifyContent: 'left' });

const labelStyle: CSSProperties = {
    marginTop: '6px',
    lineHeight: '12px',
    letterSpacing: '1px',
    display: 'flex',
    alignSelf: 'flex-start',
    fontSize: '12px',
    fontWeight: 100,
    color: Tgcc.Styles.darkTextColor,
    maxWidth: '35%',
    fontFamily: 'Reitam',
};
let checkLabelStyle = Object.assign({}, labelStyle, { maxWidth: '80%' });

const inputStyle: CSSProperties = {
    fontSize: '13px',
    display: 'flex',
    flexGrow: 2,
    marginLeft: '6px',
    padding: '0 5px',
    lineHeight: '18px',
    height: '22px',
    fontFamily: 'AveriaSerifLight',
    border: '1px solid #E9E6E6',
};

let nameStyle = Object.assign({}, inputStyle, { width: '70px' });
let phoneStyle = Object.assign({}, inputStyle, { width: '110px' });
let addrStyle = Object.assign({}, inputStyle, { width: '120px' });
let cityStyle = Object.assign({}, inputStyle, { width: '80px', marginLeft: '0', marginTop: '3px' });
let stateStyle = Object.assign({}, inputStyle, { width: '36px', marginTop: '3px', flexGrow: '0', textAlign: 'center' });
let zipStyle = Object.assign({}, inputStyle, { width: '45px', marginTop: '3px' });
let labelSOBStyle = Object.assign({}, labelStyle, { marginTop: '3px' });
let schStyle = Object.assign({}, inputStyle, { width: '315px', marginLeft: '0' });
let checkStyle = Object.assign({}, inputStyle, { width: '15px', height: '15px', flexGrow: null });

const btnStyle: CSSProperties = {
    width: '225px',
    height: '40px',
    lineHeight: '2.5',
    textAlign: 'center',
    margin: 'auto',
    fontFamily: 'Reitam',
    color: 'white',
    backgroundColor: 'rgb(226, 117, 88)',
    cursor: 'pointer',
};

const popupStyle: CSSProperties = {
    position: 'fixed',
    top: '20%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#f0f8f7',
    border: '1px solid #007BFF',
    borderRadius: '8px',
    padding: '15px 25px',
    textAlign: 'center',
    zIndex: 1000,
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
};

const dismissButtonStyle: CSSProperties = {
    marginTop: '10px',
    padding: '8px 16px',
    fontSize: '14px',
    backgroundColor: '#007BFF',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
};

export class _IndigoAccountInfo extends React.Component<Props, any> {
    state = {
        user: new Tgcc.UserInfo(),
        error: null,
        isWaiting: false,
        showPopup: false,
    };

    componentWillMount() {
        this.setState({ user: this.props.userInfo });
    }

    componentWillReceiveProps(newProps: Props) {
        this.setState({ user: newProps.userInfo });
    }

    updateUser = () => {
        const loginData = this.props.loginData;
        if (!loginData) {
            this.setState({ error: 'Not logged in', isWaiting: false });
        } else {
            const emailUpdated = this.state.user.email !== this.props.userInfo.email;
            this.setState({ isWaiting: true });

            Request.updateUser(
                loginData,
                this.state.user,
                () => this.updateComplete(emailUpdated),
                this.updateError
            );
        }
    };

    updateComplete = (emailUpdated: boolean) => {
        this.setState({ error: 'Account updated', isWaiting: false });
    
        // Merge in all the changed fields, but keep the old email if it’s pending confirmation
        const { user } = this.state;
        const oldEmail = this.props.userInfo.email;
        const userToStore = {
            ...user,
            email: emailUpdated ? oldEmail : user.email,
        };
    
        // Dispatch the profile update (email stays old when pending)
        this.props.dispatch({
            type: Tgcc.StateAction.SetUserInfo,
            payload: userToStore
        });
    
        if (emailUpdated) {
            this.setState({ showPopup: true });
        }
    };
    

    dismissPopup = () => {
        this.setState({ showPopup: false });
    };

    updateError = (err: string) => {
        this.setState({ error: err, isWaiting: false });
    };

    fieldChanged = (evt: React.SyntheticEvent<HTMLInputElement>) => {
        const el = evt.currentTarget;
        const item = {};

        if (el.name === 'Phone') item[el.name] = Tgcc.formatPhoneNumber(el.value);
        else if (el.name === 'smsAllowed') item[el.name] = el.checked;
        else item[el.name] = el.value;

        this.setState({ error: null, user: Object.assign({}, this.state.user, item) });
    };

    render() {
        const { user, error, showPopup } = this.state;

        return (
            <CampusDashboardCard title="Update Info">
                {showPopup && (
                    <div style={popupStyle}>
                        <strong>CHECK YOUR EMAIL</strong>
                        <p>Please confirm your new email address via the link sent to your inbox.</p>
                        <button style={dismissButtonStyle} onClick={this.dismissPopup}>
                            Dismiss
                        </button>
                    </div>
                )}
                <div style={rowStyle}>
                    <div style={labelStyle}>Resort/Store Name</div>
                    <input
                        name="schoolOrBusiness"
                        type="text"
                        style={schStyle}
                        value={user.schoolOrBusiness || ''}
                        onChange={this.fieldChanged}
                    />
                </div>
                <div style={rowStyle}>
                    <div style={labelStyle}>Name</div>
                    <input
                        name="firstName"
                        type="text"
                        style={nameStyle}
                        value={user.firstName || ''}
                        placeholder="first name"
                        onChange={this.fieldChanged}
                    />
                    <input
                        name="lastName"
                        type="text"
                        style={nameStyle}
                        value={user.lastName || ''}
                        placeholder="last name"
                        onChange={this.fieldChanged}
                    />
                </div>
                <div style={rowStyle}>
                    <div style={labelStyle}>Phone</div>
                    <input
                        name="phone"
                        type="tel"
                        style={phoneStyle}
                        value={user.phone || ''}
                        placeholder="daytime phone"
                        onChange={this.fieldChanged}
                    />
                </div>
                <div style={checkRowStyle}>
                    <div style={checkLabelStyle}>Send text notifications</div>
                    <input
                        name="smsAllowed"
                        type="checkbox"
                        style={checkStyle}
                        checked={user.smsAllowed || false}
                        onChange={this.fieldChanged}
                    />
                </div>
                <div style={rowStyle}>
                    <div style={labelStyle}>Email</div>
                    <input
                        name="email"
                        type="email"
                        style={inputStyle}
                        value={user.email || ''}
                        placeholder="email address"
                        onChange={this.fieldChanged}
                    />
                </div>
                <div style={rowStyle}>
                    <div style={labelStyle}>Address</div>
                    <input
                        name="address"
                        type="text"
                        style={addrStyle}
                        value={user.address || ''}
                        placeholder="shipping address"
                        onChange={this.fieldChanged}
                    />
                </div>
                <div style={addrRow2Style}>
                    <input
                        name="city"
                        type="text"
                        style={cityStyle}
                        value={user.city || ''}
                        placeholder="city"
                        onChange={this.fieldChanged}
                    />
                    <input
                        name="state"
                        type="text"
                        maxLength={2}
                        style={stateStyle}
                        value={user.state || ''}
                        placeholder="state"
                        onChange={this.fieldChanged}
                    />
                    <input
                        name="zip"
                        type="text"
                        maxLength={8}
                        style={zipStyle}
                        value={user.zip || ''}
                        placeholder="zip"
                        onChange={this.fieldChanged}
                    />
                </div>
                {error ? <div style={Tgcc.Styles.error}>{error}</div> : <div style={Tgcc.Styles.error}>&nbsp;</div>}
                <div style={btnStyle} onClick={this.updateUser}>
                    Update
                </div>
            </CampusDashboardCard>
        );
    }
}

// Map Redux state to props
const mapStateToProps = (state: Tgcc.GlobalState) => ({
    userInfo: state.UserInfo,
    loginData: state.LoginData,
});

// Connect IndigoAccountInfo to Redux
export const IndigoAccountInfo = connect(mapStateToProps)(Radium(_IndigoAccountInfo));
